import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";

const Studydestinations = () => {
const [isScrolled, setIsScrolled] = useState(false);
   useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 10) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
  const destinations = [
    {
      id: 1,
      title: "Study in Canada",
      image: "https://imgs.search.brave.com/caFOgEtUhzV0dvXwavUNa_OjAU0qdTSgTx1ym_4cVnE/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/cHJlbWl1bS1waG90/by9jYW5hZGEtd2F2/aW5nLWZsYWdfOTM2/NzUtMTczNjcuanBn/P3NlbXQ9YWlzX2h5/YnJpZA",
      alt: "Canada",
    },
    {
      id: 2,
      title: "Study in UK",
      image: "https://imgs.search.brave.com/nFPqzO-yFp7JiLK8U_R2MkCWNU0h2LDQkDguKpwIMkU/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvOTM0/NDMxMjYvcGhvdG8v/dWstZmxhZy13YXZp/bmctaW4tc3Vubnkt/Ymx1ZS1za2llcy5q/cGc_cz02MTJ4NjEy/Jnc9MCZrPTIwJmM9/REZwZ1pIYUFfTnhx/Qk1KOWFfSm50bnRi/aXlmYlpPZ3ZaOU56/OEI5WW82ND0",
      alt: "UK",
    },
    {
      id: 3,
      title: "Study in the US",
      image: "https://imgs.search.brave.com/PhMyUt3f9qAG0_-UthtMsLuAg_Qr23E7hPHRSZ2mQqc/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvMTQz/NTUyMjQxNy9waG90/by9hbWVyaWNhbi1m/bGFnLWNsb3NlLXVw/LmpwZz9zPTYxMng2/MTImdz0wJms9MjAm/Yz1nUTFZN2FUZ29P/Z2lDNHE1czFFWlFG/Yk5oSkd1LTRCU1dv/UkhUVGljY1lFPQ ",
      alt: "US",
    },
    {
      id: 4,
      title: "Study in Australia",
      image: "https://imgs.search.brave.com/EtFPdIzE_LUvf1unjnO3EHf_86DOZjC6bHWNyA2LTtU/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvMTc0/Njk0NjY1L3Bob3Rv/L2F1c3RyYWxpYW4t/ZmxhZy5qcGc_cz02/MTJ4NjEyJnc9MCZr/PTIwJmM9T0hqbE81/VEh4MkctbWdoQjB3/S1hoYktFd1N0bl9C/ejk5Ynlmczc2OXFZ/RT0",
      alt: "Australia",
    },
    {
      id: 5,
      title: "Study in Ireland",
      image: "https://imgs.search.brave.com/AbhviGf91VMY5Fyl-o8YSqZf7VKnhZR1X6ELgbKNCeM/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvNTE0/MTc3NDUxL3Bob3Rv/L2lyaXNoLWZsYWct/ZmxhZy1vZi1pcmVs/YW5kLmpwZz9zPTYx/Mng2MTImdz0wJms9/MjAmYz1ZVDJKRWV4/bVU3bUhjZXE2Qmxt/RW5GaHFZUnZYUDNP/UDFfZ29xdHFGalJF/PQ",
      alt: "Ireland",
    },
  ];

  return (
    <section className="py-16  ">
      <div className="container mx-auto  w-[80%]">
        <h2 className="text-2xl md:text-2xl lg:text-4xl notoh font-bold  text-center mb-8 text-gray-800  ">
          Study In Your Dream Destination
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {destinations.map((destination) => (
            <div
              key={destination.id}
              className="bg-white rounded-lg shadow-md overflow-hidden text-center p-4"
            >
              <img
                src={destination.image}
                alt={destination.alt}
                className="w-full h-32 object-cover mb-4"
              />
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                {destination.title}
              </h3>
              <Link to='/programs' onClick={scrollToTop}>
              <a
                href="#"
                className="text-blue-600 font-medium hover:underline inline-flex items-center hover:underline-offset-4"
              >
                Explore <span className="ml-1">&#8594;</span>
              </a>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Studydestinations;
